import React from 'react'
import Wizard from '@modules/form-wizard'
import SERVICE_PROPS from '@helpers/extract-service-props'
import { fullName } from '@modules/form-wizard/utils'
import Swal from 'sweetalert2'
import toastr from '@modules/toastr'
import moment from 'moment'
import { multiUpload } from '@helpers/file-to-base64'
import { renderFormPartASummary, renderFormPartAFullDetails } from './env_clearance_form_a_summary'



export default class EnvironmentClearanceSupplementaryFormPartB extends React.Component {
  resource = '/moen/depp/env_clearance_part_bs'
  form_key = 'env_clearance_part_b'
  defaults = {
    prev_app_on_mgw: true,// In the future modifications may be made to allow users to submit this form without a previous application on MyGateWay, but for now, it is required to have a previous application
    prev_app: true, // Default value to true since this is a supplementary form, and should only be filled if there is a previous application
  }
  state = { record: null, loading: false, formPartA: null, previous_forms: [], all_reviewers: [] }

  // Delete lines as needed
//   fee           = 99
  free          = true
//   postpaid      = true
  skip_location = true
  hide_buttons  = {
    status: true,
    deny: true,
  }

  metricRegex = /[m3]|\D/gm

  foremost = null

  async componentDidMount() {
    try {
      const { data } = await $app.axios.get(`${this.resource}/show_previous_forms`)
      // console.log('Previous forms data:', data);
      this.setState({
        previous_forms: data.records
      })
    } catch (error) {
      console.error(error)
    }
  }  

  validate = async values => {
    const update = {}

    // Save combined value and metric for coast distance and total area fields
    update.chemicals_qty = `${values.chemicals_qty || ''} ${values.chemicals_qty_metric || ''}`.trim()
    update.chemicals_consumption_rate = `${values.chemicals_consumption_rate || ''} ${values.chemicals_consumption_rate_metric || ''}`.trim()
    update.require_storage_waste_qty = `${values.require_storage_waste_qty || ''} ${values.require_storage_waste_qty_metric || ''}`.trim()
    update.require_storage_material_qty = `${values.require_storage_material_qty || ''} ${values.require_storage_material_qty_metric || ''}`.trim()

    return update
  }

  custom_actions = [
    // Document Upload for Citizen
    {
      text: 'Upload Document',
      icon: 'file-upload',
      roles: [['pilot']],
      user: true,
      test: r => ['document requested'].includes(r.application_decision),
      fn: async record => {
        const requested = (record.document_requested ?? '').replace(/"/g, '&quot;')

        // One title / description / file group per document being uploaded
        const row = (title = '') => `
          <div class='upload__row' data-row>
            <header>
              <span data-label></span>
              <button type='button' data-remove title='Remove'>&times;</button>
            </header>
            <input
              class='swal2-input'
              data-title
              placeholder='Document title'
              value="${title}"
            >
            <textarea
              class='swal2-textarea'
              data-desc
              placeholder='Please enter a brief description of this document...'
            ></textarea>
            <input
              class='swal2-file'
              type='file'
              data-file
              accept='image/*,application/pdf'
            >
          </div>
        `

        const { isDismissed, value } = await Swal.fire({
          icon: 'question',
          title: 'Upload Requested Document(s)',
          width: '42rem',
          html: `
            <style>
              #upload__rows .upload__row {
                margin-bottom: 0.75rem;
                padding: 0.75rem;
                border: 1px solid #e3e7ed;
                border-radius: 0.25rem;
                text-align: left;
              }

              #upload__rows header {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 0.5rem;
                font-weight: 600;
              }

              #upload__rows [data-remove] {
                border: none;
                background: none;
                color: #a0aec0;
                font-size: 1.25rem;
                line-height: 1;
                cursor: pointer;
              }

              #upload__rows [hidden] {
                display: none !important;
              }

              #upload__rows .swal2-input,
              #upload__rows .swal2-textarea,
              #upload__rows .swal2-file {
                display: block;
                width: 100%;
                margin: 0 0 0.5rem;
                font-size: 1rem;
              }

              #upload__rows .swal2-textarea {
                height: 5rem;
                min-height: 0;
              }

              #upload__add {
                padding: 0.4rem 0.9rem;
                border: 1px solid #cbd5e0;
                border-radius: 0.25rem;
                background: #f7fafc;
                cursor: pointer;
              }
            </style>

            ${record.document_requested ? `
              <div class="text-left mb-2">
                <strong>Document requested:</strong> ${record.document_requested}
              </div>
            ` : ''}

            <div id='upload__rows'></div>

            <button type='button' id='upload__add'>
              <i class='fas fa-plus-circle'></i>&nbsp; Add Another Document
            </button>
          `,
          showCancelButton: true,
          confirmButtonText: 'Upload',
          didOpen: () => {
            const container = document.getElementById('upload__rows')

            // Keep the row numbering in sync, and only offer removal
            // once there is more than one document in the list
            const refresh = () => {
              const rows = container.querySelectorAll('[data-row]')

              rows.forEach((el, i) => {
                el.querySelector('[data-label]').textContent = `Document #${i + 1}`
                el.querySelector('[data-remove]').hidden = rows.length < 2
              })
            }

            container.addEventListener('click', ev => {
              const button = ev.target.closest('[data-remove]')
              if (!button) return

              button.closest('[data-row]').remove()
              refresh()
            })

            document.getElementById('upload__add').addEventListener('click', () => {
              container.insertAdjacentHTML('beforeend', row())
              refresh()
            })

            container.insertAdjacentHTML('beforeend', row(requested))
            refresh()
          },
          preConfirm: () => {
            const rows = [...document.querySelectorAll('#upload__rows [data-row]')]
            const documents = []

            for (const [i, el] of rows.entries()) {
              const title = el.querySelector('[data-title]').value.trim()
              const desc = el.querySelector('[data-desc]').value.trim()
              const { files } = el.querySelector('[data-file]')

              if (!title) {
                Swal.showValidationMessage(`Please enter a title for document #${i + 1}`)
                return false
              }

              if (!desc) {
                Swal.showValidationMessage(`Please enter a description for document #${i + 1}`)
                return false
              }

              if (!files?.length) {
                Swal.showValidationMessage(`Please select a file for document #${i + 1}`)
                return false
              }

              documents.push({ title, desc, file: files[0] })
            }

            if (!documents.length) {
              Swal.showValidationMessage('Please add at least one document')
              return false
            }

            return documents
          },
        })

        if (isDismissed || !value?.length) return

        this.setState({ loading: true })
        const { resource, form_key } = this

        try {
          const multiple_uploads = await Promise.all(
            value.map(doc => (multiUpload(doc.title, doc.desc, doc.file)))
          )

          await $app.axios.put(resource + '/upload_document', {
            [form_key]: {
              form_num: record.form_num,
              multiple_uploads,
            },
          })

          toastr.success(
            'Success',
            `${value.length > 1 ? 'Documents' : 'Document'} uploaded successfully`
          )
        } catch (err) {
          console.error(err)
          Swal.fire(
            'Oops...',
            err.response?.data?.error || 'An error occurred while uploading your document',
            'error'
          )
        } finally {
          this.setState({ loading: false })
        }
      }
    },

    // Senior Officer Actions
    {
      text: 'Assign Officer',
      icon: 'bullhorn',
      roles: [['senior_officer', 'director', 'deputy_director']],
      test: r => ['pending', 'processing'].includes(r.application_decision),
      fn: async record => {
        // Get the list of officers
        const officerList = {};
        const { data } = await $app.axios.get(`${this.resource}/show_reviewers`)
        const officerMap = data.records.map(x => {
          return { id: x.id, name: `${x.first_name} ${x.last_name}` }
        })
        this.setState({ all_reviewers: officerMap })
        this.state.all_reviewers.forEach(e => {
          officerList[`${e.id}`] = e.name;
        })

        let officerID = null
        const {isDismissed, value} = await Swal.fire({
          icon: 'question',
          title: 'Assign Officer for review',
          html: `
            Select which officer you would wish to assign to this application.
          `,
          input: 'select',
          inputOptions: officerList,
          showCancelButton: true,
          confirmButtonText: 'Send',
        })
  
        if (isDismissed) return

        officerID = value
        // console.log(officerID)
        this.setState({ loading: true })
        const { props, resource, form_key } = this
        const { history, location } = props

        try {
          await $app.axios.put(resource + '/update_application', {
            [form_key]: {
              form_num: record.form_num,
              application_decision: 'assign reviewer',
              reviewer_id: officerID,
            },
          })

          if (location?.state?.view) {
            const view = { ...location.state.view }
            console.log(view)
            view.application_decision = 'assigned reviewer'

            history.replace(location.pathname, {
              ...location.state,
              view,
            })
          }

          toastr.success('Success', 'Application approved for review successfully')
        } catch (err) {
          console.error(err)
          const errMessage = err.response?.data?.message || err.message
          Swal.fire(
            'Oops...',
            `An error occurred while assigning an officer to the application.\n${errMessage}`,
            'error'
          )
        } finally {
          this.setState({ loading: false })
        }
      }
    },

    // All Officer Actions
    {
      text: 'Claim Application',
      icon: 'check',
      roles: [['officer', 'senior_officer', 'director', 'deputy_director']],
      test: r => {
        if (['pending', 'processing'].includes(r.application_decision) && r.reviewer_id == null) {
          return true
        }

        if (['pending', 'processing'].includes(r.application_decision) && $app.hasAnyRole(['senior_officer', 'director', 'deputy_director']) && r.reviewer_id != $app.current_user.id) {
          return true
        }

        return false
      },
      fn: async record => {
        const { isDismissed, value } = await Swal.fire({
          icon: 'question',
          title: 'Claim Application for Review',
          html: `
            Are you claiming this application for review, 
            <strong>${fullName(record.user, 'initial')}</strong>?
          `,
          input: 'select',
          inputOptions: {
            'claimed': "I claim this application for review",
            'no': "I do not wish to claim this application",            
          },
          showCancelButton: true,
        })

        if (isDismissed) return
        if (value === 'no') return

        this.setState({ loading: true })
        const { props, resource, form_key } = this
        const { history, location } = props

        try {
          await $app.axios.put(resource + '/update_application', {
            [form_key]: {
              form_num: record.form_num,
              application_decision: value,
            },
          })

          if (location?.state?.view) {
            const view = { ...location.state.view }
            console.log(view)
            view.application_decision = 'claimed'

            history.replace(location.pathname, {
              ...location.state,
              view,
            })
          }

          toastr.success('Success', 'Application review submitted successfully')
        } catch (err) {
          console.error(err)
          const errMessage = err.response?.data?.message || err.message
          Swal.fire(
            'Oops...',
            `An error occurred while claiming the application.\n${errMessage}`,
            'error'
          )
        } finally {
          this.setState({ loading: false })
        }
      }
    },
    {
      text: 'Request Documents',
      icon: 'check',
      roles: [['officer', 'senior_officer', 'director', 'deputy_director']],
      test: r => {
        if (['pending', 'processing', 'document requested'].includes(r.application_decision) && r.reviewer_id == $app.current_user.id) {
          return true
        }

       if ($app.hasAnyRole(['director', 'deputy_director']) && !['approved', 'denied'].includes(r.application_decision)) {
          return true
        }

        return false
      },
      fn: async record => {
        let { isDismissed, value } = await Swal.fire({
          icon: 'question',
          title: 'Request Environmental Documents',
          html: `
            Which environmental document(s) would you like to request from the applicant for further review of this application, 
            <strong>${fullName(record.user, 'initial')}</strong>?
          `,
          input: 'select',
          inputOptions: {
            'environmental baseline assessment': "Request Environmental Baseline Assessment",
            'environmental management plan': "Request Environmental Management Plan",
            'environmental impact assessment': "Request Environmental Impact Assessment",
            'geotechnical survey': "Request Geotechnical Survey",
            'hydrologic assessment': "Request Hydrologic Assessment",
            'traffic study': "Request Traffic Study",
            'coastal engineering study': "Request Coastal Engineering Study",
            'other': "Other (please specify)",     
          },
          showCancelButton: true,
        })

        if (isDismissed) return
        if (value === 'other') {
          const { isDismissed: isDismissedOther, value: valueOther } = await Swal.fire({
            icon: 'info',
            title: 'Request Other Environmental Document',
            html: `
              Please specify the other environmental document you would like to request from the applicant for further review of this application, 
              <strong>${fullName(record.user, 'initial')}</strong>?
            `,
            input: 'textarea',
            showCancelButton: true,
          })

          if (isDismissedOther) return
          if (!valueOther) return
          value = valueOther
        }

        this.setState({ loading: true })
        const { props, resource, form_key } = this
        const { history, location } = props

        try {
          await $app.axios.put(resource + '/update_application', {
            [form_key]: {
              form_num: record.form_num,
              application_decision: 'document requested',
              document_requested: value,
            },
          })

          if (location?.state?.view) {
            const view = { ...location.state.view }
            console.log(view)
            view.application_decision = 'document requested'

            history.replace(location.pathname, {
              ...location.state,
              view,
            })
          }

          toastr.success('Success', 'Application updated successfully')
        } catch (err) {
          console.error(err)
          const errMessage = err.response?.data?.message || err.message
          Swal.fire(
            'Oops...',
            `An error occurred while updating the application.\n${errMessage}`,
            'error'
          )
        } finally {
          this.setState({ loading: false })
        }
      }
    },
    {
      text: 'Approve Application',
      icon: 'check-square',
      roles: [['officer', 'senior_officer', 'director', 'deputy_director']],
      test: r => {
        if (['pending', 'processing', 'document requested'].includes(r.application_decision) && r.reviewer_id == $app.current_user.id) {
          return true
        }

        if ($app.hasAnyRole(['director', 'deputy_director']) && !['approved', 'denied'].includes(r.application_decision)) {
          return true
        }

        return false
      },
      fn: async record => {
        let { isDismissed, value } = await Swal.fire({
          icon: 'question',
          title: 'Are you sure that you would like to approve this application?',
          html: `
            By selecting "Confirm", you are acknowleding that you have reviewed this application and are satisfied with its contents. Would you like to approve?
          `,
          input: 'select',
          inputOptions: {
            'yes': "Yes approve",
            'no': "Cancel",
            'other': "Yes, approve with custom messaging (please specify)",     
          },
          showCancelButton: true,
        })

        if (isDismissed) return
        if (value === 'no') return
        if (value === 'other') {
          const { isDismissed: isDismissedOther, value: valueOther } = await Swal.fire({
            icon: 'info',
            title: 'Approve Application with Custom Message',
            html: `
              ${record.custom_message ? `
                <div class="text-left mb-2">
                  <strong>Current message:</strong><br/>${record.custom_message}
                </div>
              ` : ''}
              Please specify the custom message you would like to include when approving this application for further review of this application,
              <strong>${fullName(record.user, 'initial')}</strong>?
            `,
            input: 'textarea',
            inputAttributes: { rows: 6 },
            showCancelButton: true,
          })

          if (isDismissedOther) return
          if (!valueOther) return
          value = valueOther
        }

        if (value === 'yes') value = null

        const expiry = moment(record.license_expiry_date)
        const hasExpiry = !!record.license_expiry_date && expiry.isValid()

        const { isDismissed: isDismissedExpiry, value: months } = await Swal.fire({
          icon: 'info',
          title: 'Set Licence Expiry Date',
          html: `
            ${hasExpiry ? `
              <div class="text-left mb-2">
                <strong>Current expiry date:</strong> ${expiry.format('MMMM Do YYYY')}
              </div>
            ` : ''}
            Please enter the number of months the licence being issued with this approval
            will remain valid for. The expiry date is calculated from today's date.
          `,
          input: 'number',
          inputPlaceholder: 'Number of months',
          inputAttributes: { min: 1, step: 1 },
          showCancelButton: true,
          confirmButtonText: 'Approve',
          inputValidator: val => {
            const num = Number(val)

            if (!val || !Number.isInteger(num) || num < 1) {
              return 'Please enter a valid number of months'
            }
          },
        })

        if (isDismissedExpiry) return
        if (!months) return

        const license_expiry_date = moment()
          .add(Number(months), 'months')
          .format('YYYY-MM-DD')

        this.approve(record, value, license_expiry_date)
      }
    },
    {
      text: 'Deny',
      icon: 'ban',
      roles: [['officer', 'senior_officer', 'director', 'deputy_director']],
      test: r => {
        if (['pending', 'processing', 'document requested'].includes(r.application_decision) && r.reviewer_id == $app.current_user.id) {
          return true
        }

        if ($app.hasAnyRole(['director', 'deputy_director']) && !['approved', 'denied'].includes(r.application_decision)) {
          return true
        }

        return false
      },
      fn: record =>
        Swal.fire({
          icon: 'error',
          title: 'Confirm Denial',
          text: 'Are you sure you want to deny this application?',
          confirmButtonText: 'Deny',
          showCancelButton: true,
        }).then(async result => {
          if (result.isConfirmed) {
            await this.deny(record)
          }
        }),
    },
  ]

  approve = async (record, custom_message = '', license_expiry_date = null) => {
    this.setState({ loading: true })

    const { props, resource, form_key } = this
    const { history, location } = props
    const { axios } = $app

    try {
      await axios.put(resource + '/update_application', {
        [form_key]: {
          form_num: record.form_num,
          application_decision: 'approved',
          custom_message,
          license_expiry_date,
        },
      })

      if (location.state?.view) {
        const view = { ...location.state.view }
        view.application_decision = 'approved'

        history.replace(location.pathname, { ...location.state, view })
      }

      toastr.success('Success', 'Application successfully approved')
    } catch (error) {
      console.error(error)
      // console.log(error.response)
      toastr.error('Error', error.response?.data?.error || 'Unable to approve application')
    } finally {
      this.setState({ loading: false })
    }
  }

  deny = async record => {
    this.setState({ loading: true })

    const { props, resource, form_key } = this
    const { history, location } = props
    const { axios } = $app

    try {
      await axios.put(resource + '/update_application', {
        [form_key]: {
          form_num: record.form_num,
          application_decision: 'denied',
        },
      })

      if (location.state?.view) {
        const view = { ...location.state.view }
        view.application_decision = 'denied'

        history.replace(location.pathname, { ...location.state, view })
      }

      toastr.success('Success', 'Application denied')
    } catch (error) {
      console.error(error)
      toastr.error('Error', error.response?.data?.error || 'Unable to deny application')
    } finally {
      this.setState({ loading: false })
    }
  }

  purposeDescriptions = {
    'existing structure': 'To repair, perform maintenance, or conduct a minor alteration of an existing public or private structure',
    'minor ops/maint': `Operation, repair, maintenance, or minor alteration of existing public 
        or private structures, facilities, mechanical equipment, or 
        topographical features,  that does not result in any change to the 
        existing structures, facilities, equipment, or features`,
    'small res build': 'The construction of a residential dwelling (single family), not exceeding a six multi-family dwelling',
    'abandon/decomm': 'Abandonment/Decommissioning',
    'new commercial': 'New large scale commercial development',
    'new subdiv/dev': 'New Housing Subdivision or Development',
  }

  columns = props => {
    const purposeFinder = value => {
      return Object.keys(this.purposeDescriptions).find(key => this.purposeDescriptions[key] === value) || value
    }

    return [
      {
        name: 'Project Island',
        width: '160px',
        selector: row => row?.form_part_a?.project_island || 'N/A',
        sortable: true,
        searchable: r => r?.form_part_a?.project_island,
      },
      {
        name: 'Purpose',
        selector: row => row?.form_part_a?.purpose_list ? row.form_part_a.purpose_list.map(item => purposeFinder(item)).join(', ') : 'N/A',
        sortable: true,
        searchable: r => r?.form_part_a?.purpose_list,
        hint: this.purposeDescriptions['existing structure']
      },
      {
        name: 'Officer Assigned',
        width: '200px',
        selector: row => row.reviewer ? `
          ${row.reviewer.first_name[0].toUpperCase() + row.reviewer.first_name.substring(1)} ${row.reviewer.last_name[0].toUpperCase() + row.reviewer.last_name.substring(1)}
        ` : 'N/A',
        sortable: true,
        // searchable: r => r.reviewer,
      },
    ]
  }

  prevAppQuestion = form => {
    if (form.prev_app_on_mgw) {
      const part_a_form = this.state.previous_forms.find(x => x.form_num === form.prev_app_ref_no)

      return [
        {
          name: 'prev_app_ref_no',
          label: 'Related application for form continuation (Part A)',
          options: this.state.previous_forms.map(x => ({ label: x.project_name ? `${x.project_name} - ${x.form_num}` : `${x.project_island} - ${x.form_num}`, value: x.form_num })),
          hide: !form.prev_app
        },
        {
          heading: renderFormPartASummary(part_a_form),
          view: false
        },
      ]
    } else {
      return [
        {
          name: 'prev_app_ref_no',
          label: 'Reference No. of most recent application (Part A)',
          type: 'text',
          hide: !form.prev_app,
        },
      ]
    }
  }

  fields = (form, formRef) => {
    // const { formPartA } = this.state
    // const partAFormOptions = []
    // console.log(partAFormOptions)
    form.prev_app = true // Default value to true since this is a supplementary form, and should only be filled if there is a previous application

    return [
      {
        name: 'form_part_a_details',
        hide: true,
        view: {
          element: (value, form) => renderFormPartAFullDetails(form.form_part_a)
        }
      },
      {
          heading: '<h2>PART B</h2>'
      },

      {
          name: 'prev_app',
          label: 'Previous Application for Certificate of Environmental Clearance (Part A) for this site?',
          type: 'select:bool',
          save: false,
          disabled: true,
          value: true, // Default value to true since this is a supplementary form, and should only be filled if there is a previous application
          view: {
            value: () => 'Yes',
          }
      },
      {
        name: 'prev_app_on_mgw',
        label: 'Was the previous application for this site submitted on MyGateWay?',
        type: 'select:bool',
        disabled: true,
        save: false,
        view: false,
        hide: !form.prev_app
      },
      ...this.prevAppQuestion(form),

      "::SPACER",
      {
          heading: '<h4 style="font-weight:bold;">A. General Information</h4>'
      },

      `::10. Site Description (physical setting of the proposal, both developed and undeveloped areas).
        Give an outline description of the physical features of the site to include information on:`,
      {
        name: 'topography_desc',
        label: 'Topography and gradient',
        hint: 'Generally flat rolling/undulating terrain or hilly',
        type: 'textarea'
      },
      {
        name: 'springs_desc',
        label: 'Are there any springs or aquifers in or adjacent to the site?',
        hint: 'Aquifers are massive underground layers of porous or fractured rock, sand, and gravel that hold groundwater',
        type: 'select:bool',
      },
      {
        name: 'lakes_bool',
        label: 'Are there any lakes or drainage within or adjacent to the project site?',
        type: 'select:bool',
      },
      {
        name: 'ponds_bool',
        label: 'Are there any ponds, reservoirs or wetland areas within or contiguous to the project site?',
        type: 'select:bool',
      },
      {
        name: 'soil_type',
        label: 'What is the predominant soil type?',
        options: ['Clay Based', 'Sand', 'Loam', 'Alluvial']
      },
      `::11. Estimated project capital:`,
      {
        name: 'estimated_capital',
        label: 'Estimated project capital',
        type: 'currency'
      },

      "::SPACER",
      {
          heading: '<h4 style="font-weight:bold;">B. DESCRIPTION OF INTENDED ACTIVITY</h4>'
      },
      "::12. Description of the Intended Activity, which must include information on:",
      {
        name: 'total_surface_area_covered',
        label: `a. Percentage of the total surface area allocated to covered space and paved areas `,
        type: 'number',
        icon: 'text-%',
        min: 0,
        max: 100,
        onBlur: v => {
          if (v < 0) return { total_surface_area_covered: 0 }
          if (v > 100) return { total_surface_area_covered: 100 }
        },
        view: v => `${v}%`
      },
      {
          name: 'portable_water_consumption',
          label: 'b. Portable water consumption rate (m3/day)',
          type: 'number',
          icon: 'text-m3/day',
      },
      {
          name: 'process_water_consumption',
          label: 'c. Process water consumption rate (m3/day)',
          type: 'number',
          icon: 'text-m3/day',
      },
      {
          name: 'production_output',
          label: 'd. Production output rate, if different from above',
          hint: '(metric tonnes/m3 per annum)',
          type: 'number',
          icon: 'text-m3/annum',
          required: false,
      },

      "::SPACER",
      "::Site Preparation and Construction Phase",

      {
        name: 'require_earthworks_bool',
        label: '13. Does the project site require major earthworks such as clearing, cutting, excavation, grading, blasting, or dredging?',
        type: 'select:bool',
      },
      {
        name: 'earthworks_desc',
        label: 'a. State the method of disposal (and disposal site) of material generated as a result',
        type: 'textarea',
        hide: !form.require_earthworks_bool
      },
      {
        name: 'require_filling_bool',
        label: 'b. Does the site require filling, reclamation, coastline stabilization/alteration?',
        type: 'select:bool',
      },
      {
        name: 'filling_desc',
        label: 'b. State the source and quantity (metric tonnes) of material required',
        type: 'textarea',
        hide: !form.require_filling_bool
      },
      {
        name: 'require_waterworks_bool',
        label: 'c. Would the project require major waterworks such as abstraction, diversion of water courses, or creation of standing water bodies?',
        type: 'select:bool',
      },
      {
        name: 'waterworks_desc',
        label: 'c. Give an estimate of the volume of water to be impounded (m3) or the rate of abstraction (m3/day) and the source of this water',
        type: 'textarea',
        hide: !form.require_waterworks_bool
      },

      "::c. Would the site require infrastructure and utility development access to: ",
      {
        name: 'roads_bridges_bool',
        label: 'Roads or bridges?',
        type: 'select:bool',
      },
      {
        name: 'sewage_system_bool',
        label: 'Sewage system?',
        type: 'select:bool',
      },
      {
        name: 'power_system_bool',
        label: 'Power generating or transmission facilities?',
        type: 'select:bool',
      },
      {
        name: 'telecommunication_system_bool',
        label: 'Telecommunications installation?',
        type: 'select:bool',
      },
      {
        name: 'drainage_system_bool',
        label: 'Modification of a drainage system?',
        type: 'select:bool',
      },
      {
        name: 'require_relocation_bool',
        label: '14. Will the project require relocation of people houses facilities from the site?',
        type: 'select:bool',
      },
      {
        name: 'relocation_desc',
        label: 'Please give relocation details',
        type: 'textarea',
        hide: !form.require_relocation_bool
      },
      {
        name: 'mitigation_measures_list',
        label: 'State mitigation measures for adverse impacts resulting during site preparation and the construction phase',
        columns: [
            {
                name:'mitigation_measure',
                type: 'textarea'
            }
        ],
        format: v => v.mitigation_measure
      },


      "::SPACER",
      "::Operational Phase",
      {
        name: 'raw_materials_list',
        label: `State the required raw/input materials and the quantities/volumes (kg or metric 
          tonnes/m3) to be kept in stock for the project as well as their respective rates of 
          consumption (kg or metric tonnes per day/m3 per day)`,
        fields: [
          { 
            name: 'material',
            label: 'Required Raw/Input Material',
          },
          {
            name: 'quantity_or_volume_metric',
            label: 'Unit of measurement for quantity or volume and rate of consumption',
            save: false,
            view: false,
            options: [
              { label: 'kg per day', value: 'kg/day' },
              { label: 'metric tonnes (m3) per day', value: 'm3/day' },
            ],
            callback: async (v, s, index) => {
              const rawMaterialsList = form.raw_materials_list

              if (rawMaterialsList[index].quantity_or_volume) {
                rawMaterialsList[index].quantity_or_volume = `${rawMaterialsList[index].quantity_or_volume.replaceAll(this.metricRegex, '')} ${v}`
                return { raw_materials_list: rawMaterialsList }
              }
            },
          },
          {
            name: 'quantity_or_volume',
            label: 'Quantity or Volume (kg or metric tonnes/m3)',
            hint: 'kg or metric tonnes/m3',
            // type: 'integer',
            hide: (index) => !form.raw_materials_list?.[index]?.quantity_or_volume_metric,
            onBlur: async (v, s, index) => {
              const rawMaterialsList = form.raw_materials_list

              if (form.raw_materials_list[index].quantity_or_volume_metric && v) {
                rawMaterialsList[index].quantity_or_volume = `${v.replaceAll(this.metricRegex, '')} ${form.raw_materials_list[index].quantity_or_volume_metric}`
                return { raw_materials_list: rawMaterialsList }
              }
            },
          },
          {
            name: 'rate_of_consumption_metric',
            label: 'Rate of Consumption (kg per day or metric tonnes (m3) per day)',
            save: false,
            view: false,
            options: [
              { label: 'kg per day', value: 'kg/day' },
              { label: 'metric tonnes (m3) per day', value: 'm3/day' },
            ],
            callback: async (v, s, index) => {
              const rawMaterialsList = form.raw_materials_list

              if (rawMaterialsList[index].rate_of_consumption) {
                rawMaterialsList[index].rate_of_consumption = `${rawMaterialsList[index].rate_of_consumption.replaceAll(this.metricRegex, '')} ${v}`
                return { raw_materials_list: rawMaterialsList }
              }
            },
          },
          {
            name: 'rate_of_consumption',
            label: 'Rate of Consumption',
            hint: 'kg or metric tonnes/m3 per day',
            // type: 'integer',
            hide: (index) => !form.raw_materials_list?.[index]?.rate_of_consumption_metric,
            onBlur: async (v, s, index) => {
              const rawMaterialsList = form.raw_materials_list

              if (form.raw_materials_list[index].rate_of_consumption_metric && v) {
                rawMaterialsList[index].rate_of_consumption = `${v.replaceAll(this.metricRegex, '')} ${form.raw_materials_list[index].rate_of_consumption_metric}`
                return { raw_materials_list: rawMaterialsList }
              }
            },
          }
        ],
        // format: v => [v.item, v.quantity_or_volume]
      },
      {
        name: 'require_chemicals_bool',
        label: 'Would the activity require any ancillary process related chemicals?',
        hint: '(e.g. catalysts, pesticides)',
        type: 'select:bool',
      },
      {
        name: 'chemicals_qty_metric',
        label: 'a. Total quantity of chemicals (kilograms/kg or metric tonnes/m3)',
        hint: '1 kg = 1000 grams, 1 metric tonne = 1000 kg',
        save: false,
        view: false,
        hide: !form.require_chemicals_bool,
        options: [
          { label: 'kilograms/kg', value: 'kg' },
          { label: 'metric tonnes/m3', value: 'm3' },
        ],
      },
      {
        name: 'chemicals_qty',
        label: `a. Total quantity of chemicals (${form.chemicals_qty_metric})`,
        type: 'number',
        icon: `text-${form.chemicals_qty_metric}`,
        hint: `In ${form.chemicals_qty_metric}`,
        hide: !form.chemicals_qty_metric,
        view: true,
      },
      {
        name: 'chemicals_consumption_rate_metric',
        label: 'a. Total quantity of chemicals (kilograms/kg or metric tonnes/m3)',
        hint: '1 kg = 1000 grams, 1 metric tonne = 1000 kg',
        save: false,
        view: false,
        hide: !form.require_chemicals_bool,
        options: [
          { label: 'kilograms/kg', value: 'kg' },
          { label: 'metric tonnes/m3', value: 'm3' },
        ],
      },
      {
        name: 'chemicals_consumption_rate',
        label: 'State the rate of consumption (kg or metric tonnes/ m3 per day) of chemicals',
        type: 'number',
        icon: `text-${form.chemicals_consumption_rate_metric}`,
        hint: `In ${form.chemicals_consumption_rate_metric} per day`,
        hide: !form.require_chemicals_bool
      },
      {
        name: 'final_products_list',
        label: 'State the final products to be derived and the rate of production(metric tonnes/m3 per year)',
        fields: [
          'product',
          {
            name: 'rate_of_production',
            label: 'Rate of production (metric tonnes/m3 per year)',
            type: 'number',
            icon: 'text-m3/per year',
            hint: 'metric tonnes/m3 per year',
          }
        ],
        // format: v => v.rate_of_production
      },
      {
        name: 'intermediate_products_list',
        label: 'State any intermediate products resulting from this activity indicating the rate of production and the fate.(metric tonnes/m3 per year)',
        required: false,
        fields: [
          {
            name: 'product',
            required: false,
          },
          {
            name: 'rate_of_production',
            label: 'Rate of production (metric tonnes/m3 per year)',
            type: 'number',
            icon: 'text-m3/per year',
            hint: 'metric tonnes/m3 per year',
            // onBlur: async (v, s, index) => {
            //   const intermediateProductsList = form.intermediate_products_list
            //   intermediateProductsList[index].rate_of_production = `${v.replaceAll(this.metricRegex, '')} m3/year`
              
            //   return { intermediate_products_list: intermediateProductsList }
            // }
          },
          {
            name: 'fate',
            required: false,
          },
        ],
          // format: v => [v.product, v.rate_of_production]
      },
      {
        name: 'solid_waste_production_rate',
        label: 'State the rate of production of domestic solid waste generated during the operational phase. (metric tonnes/m3 per year)',
        icon: 'text-m3/per year',
        hint: 'metric tonnes/m3 per year',
        type: 'number'
      },
      {
        name: 'solid_waste_disposal_method',
        label: 'State the method of disposal of domestic solid waste generated during the operational phase.',
        type: 'textarea'
      },
      {
        name: 'solid_waste_list',
        label: 'List, characterize and quantify (metric tonnes/m3 per year) process related solid waste. State the method(s) and location intended for their disposal.',
        fields: [
          'waste_product',
          {
            name: 'waste_desc',
            label: 'Description of solid waste product'
          },
          {
            name: 'quantity',
            label: 'Quantity (metric tonnes/m3 per year)',
            hint: 'metric tonnes/m3 per year',
            type: 'number',
            icon: 'text-m3/per year',
          },
          {
            name: 'disposal_method',
            label: 'Method of disposal',
            type: 'textarea'
          },
          {
            name: 'disposal_location',
            label: 'Location intended for disposal',
            type: 'textarea'
          }
        ],
        // format: v => v.rate_of_production
      },
      {
        name: 'generation_estimates_list',
        label: 'Provide respective estimates for the rate of generation (metric tonnes/m3 per day) of domestic waste water and sewage. State the respective treatment methods intended for domestic waste water and sewage as well as their ultimate effluent points.',
        fields: [
          {
            name: 'generation_rate',
            label: 'Rate of generation for waste water and sewage (metric tonnes/m3 per day)',
            type: 'number',
            icon: 'text-m3/per day',
          },
          {
            name: 'treatment_method',
            label: 'Treatment method intended for domestic waste water and sewage',
            type: 'textarea'
          },
          {
            name: 'effluent_point',
            label: 'Ultimate effluent point for domestic waste water and sewage',
            type: 'textarea'
          }
        ],
      },
      {
        name: 'process_water_source',
        label: 'State the source of the process water',
        type: 'textarea'
      },
      {
        name: 'discharge_liquid_effluent_bool',
        label: 'Would the activity discharge process release liquid effluent?',
        type: 'select:bool',
      },
      {
        name: 'discharge_source',
        label: 'State the source of the discharge',
        type: 'textarea',
        hide: !form.discharge_liquid_effluent_bool
      },
      {
        name: 'discharge_composition',
        label: 'State the composition of the discharge',
        type: 'textarea',
        hide: !form.discharge_liquid_effluent_bool
      },
      {
        name: 'discharge_rate',
        label: 'State the rate of the discharge (m3 per day)',
        type: 'number',
        icon: 'text-m3/per day',
        hide: !form.discharge_liquid_effluent_bool
      },
      {
        name: 'discharge_effluent_point',
        label: 'State the ultimate effluent point for the discharge',
        type: 'textarea',
        hide: !form.discharge_liquid_effluent_bool
      },
      {
        name: 'utilizes_hazardous_substances_bool',
        label: 'Would this activity utilise any hazardous (i.e. toxic, flammable, explosive, radioactive etc.) substances?',
        type: 'select:bool',
      },
      {
        name: 'hazardous_substances_list',
        label: 'Provide a listing of the substances and the quantities to be used or stored.',
        fields: [
          'substance',
          { 
            name: 'quantity',
            label: 'Quantity to be stored or used',
            hint: 'include metric of measurement (eg. kg or metric tonnes/m3)',
            // type: 'integer'
            type: 'number',
            icon: 'text-m3',
          }
        ],
        hide: !form.utilizes_hazardous_substances_bool,
        // format: v => [v.substance, v.quantity]
      },
      {
        name: 'require_storage_bool',
        label: 'Would the project require storage of input or waste material on site?',
        type: 'select:bool',
      },
      {
        name: 'require_storage_waste_qty_metric',
        label: 'Give estimates of the quantities (kg or metric tonnes/m3) for the storage of waste.',
        options: [
          { label: 'kg', value: 'kg' },
          { label: 'metric tonnes/m3', value: 'm3' },
        ],
        hint: 'kg or metric tonnes/m3',
        save: false,
        view: false,
        hide: !form.require_storage_bool,
        // type: 'textarea',
      },
      {
        name: 'require_storage_waste_qty',
        label: `Give estimates of the quantities (${form.require_storage_waste_qty_metric}) for the storage of waste.`,
        icon: `text-${form.require_storage_waste_qty_metric}`,
        hint: `In ${form.require_storage_waste_qty_metric}`,
        type: 'number',
        hide: !form.require_storage_waste_qty_metric,
      },
      {
        name: 'require_storage_material_qty_metric',
        label: 'Give estimates of the quantities (kg or metric tonnes/m3) for the storage of input material.',
        options: [
          { label: 'kg', value: 'kg' },
          { label: 'metric tonnes/m3', value: 'm3' },
        ],
        hint: 'kg or metric tonnes/m3',
        save: false,
        view: false,
        hide: !form.require_storage_bool,
        // type: 'textarea',
      },
      {
        name: 'require_storage_material_qty',
        label: `Give estimates of the quantities (${form.require_storage_material_qty_metric}) for the storage of input material.`,
        icon: `text-${form.require_storage_material_qty_metric}`,
        hint: `In ${form.require_storage_material_qty_metric}`,
        type: 'number',
        hide: !form.require_storage_material_qty_metric,
      },
      {
        name: 'facilities_desc_list',
        label: 'Describe briefly the facilities allocated for this purpose',
        fields: [
          'facility',
          {
            name:'facility_desc',
            label: 'Description of facility',
            type: 'textarea'
          }
        ],
        // format: v => v.facility
      },
      {
        name: 'transport_intended_list',
        label: 'Indicate the mode(s) of transport intended for materials for the operational phase.',
        fields: [
          'mode_of_transport',
        ],
        // format: v => [v.mode_of_transport, v.equipment]
      },
      {
        name: 'equipment_intended_list',
        label: 'Indicate the equipment intended for use during the operational phase.',
        fields: [
          'equipment'
        ],
        // format: v => [v.mode_of_transport, v.equipment]
      },
      {
        name: 'air_emission_bool',
        label: 'Will the activity generate air emissions during the operational phases?',
        hint: '(i.e. particulate emissions such as dust or pollutant gaseous emissions)',
        type: 'select:bool',
      },
      {
        name: 'air_emissions_list',
        label: 'Describe types and sources and provide an estimated emission rate or loading.',
        fields: [
          {
            name: 'type_desc',
            label: 'Air emission type',
            // type: 'textarea'
          },
          {
            name: 'source_desc',
            label: 'Source of air emissions',
            type: 'textarea'
          },
          {
            name: 'emission_rate_or_load',
            label: 'Emission rate or loading',
            // type: 'integer',
            // hint: 'kg or metric tonnes per year',
          }
        ],
        hide: !form.air_emission_bool,
        // format: v => [v.type, v.source, v.emission_rate_or_load]
      },
      {
        name: 'produces_odor_bool',
        label: 'Will the activity routinely produce odours?',
        hint: '(i.e. for more than 1 hour per day)',
        type: 'select:bool',
      },
      {
        name: 'high_noise_level_bool',
        label: 'Will the activity generate significant levels of noise during its operational phase?',
        hint: '(i.e. for more than 1 hour per day at levels exceeding 60 dB)',
        type: 'select:bool',
      },
      {
        name: 'area_aesthetics_bool',
        label:'23. Will the project have adverse effects on the aesthetics of the area where it is located (i.e. result in radical changes of the landscape, such as scarring/mass vegetation removal',
        type: 'select:bool',
      },
      {
        name: 'adverse_impacts_list',
        label: 'State mitigation measures for adverse impacts resulting during the operational phase',
        fields: [
            {
                name:'mitigation_measure',
                type: 'textarea'
            }
        ],
        // format: v => v.mitigation_measure
      },
      {
        name: 'expected_lifespan',
        label: 'State the expected lifespan of this activity.',
        hint: 'include months/years in description',
      },

      "::SPACER",
      "::Confidentiality",
      {
        name: 'trade_secret_bool',
        label: '26. a) Do you consider any information provided here to be a trade secret or other confidential business information and that such information be omitted from the Register?',
        type: 'select:bool',
      },
      {
        name: 'trade_secret_desc',
        label: '26. b) Please provide details',
        type: 'textarea',
        hide: !form.trade_secret_bool,
      },
      {
        name: 'additional_info_text',
        label: '27. Other relevant information',
        type: 'textarea',
        required: false,
      },

      "::Uploads",
      {
        name:'previous_c_e_c_upload',
        key: 'image.1',
        label:'Previous Certificate of Environmental Clearance (CEC)',
        hide: !form.prev_app,
        type: 'file:all',
        required: false,
      },
      {
        name:'additional_upload',
        key: 'image.2',
        label:'Supporting documents (e.g. maps, drawings, photographs, reports, etc.)',
        type: 'file:all',
        required: false,
      },
    ]
  }

  render = () => <Wizard {...SERVICE_PROPS(this)} />

}